export default {
  // NewRichTextEditor
  writeSomething: 'Escribe algo...',
  increaseColumnWidth: 'Añadir 10% al ancho de la columna',
  decreaseColumnWidth: 'Quitar 10% al ancho de la columna',
  insertTable: 'Insertar tabla 2x2',
  deleteTable: 'Eliminar tabla',
  addColumnLeft: 'Agregar columna a la izquierda',
  addColumnRight: 'Agregar columna a la derecha',
  addRowBelow: 'Agregar fila debajo',
  addRowAbove: 'Agregar fila arriba',
  deleteRow: 'Eliminar Fila',
  deleteColumn: 'Eliminar Columna',

  // ContainerRichTextKlv3
  unsavedChangesMessage: '¿Estás seguro de que quieres cerrar? Los datos no guardados se perderán.',
  confirmationRequired: 'Confirmación Necesaria',
  yesClose: 'Sí, cerrar',
  listMode: 'Insertar en modo lista',
  listModeHelp: 'Cada línea del texto se guarda como un registro distinto.',
  listModeCount: 'Registros a crear: {count}',
  listModeCreated: 'Registros creados: {count}',
}
